import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7342be8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mdm-l-login-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Login", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please provide an API Key", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const store = useStore()
const router = useRouter()

const apiKey = ref('')

function login(): void {
  store.commit('setApiKey', apiKey.value)
  router.push('/policies')
}

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DodoButton = _resolveComponent("DodoButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode(_component_InputText, {
      modelValue: apiKey.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((apiKey).value = $event)),
      type: "text"
    }, null, 8, ["modelValue"]),
    _hoisted_5,
    _hoisted_6,
    _createVNode(_component_DodoButton, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (login()))
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Login ")
      ]),
      _: 1
    })
  ]))
}
}

})